import { WidgetDefinition } from '../models/WidgetDefinition';

export const DashboardThumbnailWidgetDefinition: WidgetDefinition = {
    baseType: 'dashboardThumbnail',
    group: 'Dashboard',
    highlights: ['Dashboard thumbnail'],
    icon: 'fa-dashboard',
    sortingOrder: 500,
    title: 'Dashboard Thumbnail',
    type: 'dashboardThumbnail'
};